import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  getConfigSuccess,
  ConfigActionTypes,
  getSegmentsSuccess,
  getSegmentsFailure,
  getConfigFailure,
  getCurrenciesFailure,
  getCurrenciesSuccess,
  getCountriesFailure,
  getCountriesSuccess,
  getIndustriesFailure,
  getIndustriesSuccess,
  getSegments,
  getCountryRegions,
  getCountryRegionsFailure,
  getCountryRegionsSuccess,
} from '../actions';
import { catchError, map, mergeMap, of } from 'rxjs';

import { IOption, SnackbarService } from '@shared';
import { Store } from '@ngrx/store';
import { IRootState } from '@app/store';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from '@app/errors/errors.service';

import { IConfigBasicData } from '@shared/model/basic-data';
import { ConfigService } from '../../services';
@Injectable()
export class ConfigEffects {
  constructor(
    private _actions$: Actions,
    private _configService: ConfigService,
    private _snackbarService: SnackbarService,
    private _errorsService: ErrorsService,
    private _store: Store<IRootState>,
  ) { }

  getConfig$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigActionTypes.GET_CONFIG),
      mergeMap(() =>
        this._configService.getConfig().pipe(
          map((config: IConfigBasicData) => getConfigSuccess({ config })),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(getConfigFailure());
          }),
        ),
      ),
    ),
  );

  getCurrencies$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigActionTypes.GET_CUREENCIES),
      mergeMap(() =>
        this._configService.getCurrencies().pipe(
          map((currencies: IOption[]) => getCurrenciesSuccess({ currencies })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getCurrenciesFailure());
          }),
        ),
      ),
    ),
  );

  getCountries$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigActionTypes.GET_COUNTRIES),
      mergeMap(() =>
        this._configService.getCountries().pipe(
          map((countries: IOption[]) => getCountriesSuccess({ countries })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getCountriesFailure());
          }),
        ),
      ),
    ),
  );

  getCountryRegions$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getCountryRegions.type),
      mergeMap(({ countryId }) =>
        this._configService.getCountryRegions(countryId).pipe(
          map((regions: IOption[]) => getCountryRegionsSuccess({ regions })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getCountryRegionsFailure());
          }),
        ),
      ),
    ),
  );

  getIndustries$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigActionTypes.GET_INDUSTRIES),
      mergeMap(() =>
        this._configService.getIndustries().pipe(
          map((industries: IOption[]) => {
            // if (industries !== undefined && industries !== null) {
            //   this._store.dispatch(getSegments());
            // }
            return getIndustriesSuccess({ industries });
          }),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getIndustriesFailure());
          }),
        ),
      ),
    ),
  );

  getSegments$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ConfigActionTypes.GET_SEGMENTS),
      mergeMap(({ industry }) => {
        return this._configService.getSegments(industry).pipe(
          map((segments: IOption[]) => {
            return getSegmentsSuccess({ segments });
          }),
          catchError(() => of(getSegmentsFailure())),
        );
      }),
    ),
  );
}
